// =============================================================================
// SIREPPAR - ¿El usuario del partido puede iniciar consultas?
// =============================================================================
// Pueden los apoderados firmantes y los apoderados iniciadores de la agrupación.
// El criterio vive solo en el backend (GET /consultas/permisos), porque depende
// del registro de apoderados; acá solo se pregunta. Ver, responder y repreguntar
// no dependen de esto.
// =============================================================================

import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { consultaService } from '../services/api';
import { puedeUsarConsultas } from '../utils/consultas';

export function usePuedeCrearConsulta(): { puedeCrear: boolean; cargando: boolean } {
  const { user } = useAuth();
  const habilitado = puedeUsarConsultas(user?.rol);
  const { data, isLoading } = useQuery({
    // Con la agrupación en la clave: al cambiar de agrupación activa se vuelve a preguntar.
    queryKey: ['consultas-permisos', user?.id, user?.partidoId],
    queryFn: () => consultaService.permisos(),
    enabled: habilitado,
    staleTime: 5 * 60_000,
  });
  return { puedeCrear: habilitado && data?.data?.puedeCrear === true, cargando: habilitado && isLoading };
}
